import { render, staticRenderFns } from "./Plots.vue?vue&type=template&id=023cb67a&scoped=true"
import script from "./Plots.vue?vue&type=script&lang=ts"
export * from "./Plots.vue?vue&type=script&lang=ts"
import style0 from "./Plots.vue?vue&type=style&index=0&id=023cb67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023cb67a",
  null
  
)

export default component.exports